// Safety check: ensure Global is available before using it
// Note: Global is defined in _global-js.liquid and should be available
if (typeof Global === 'undefined') {
  console.error('product-form.js: Global is not defined. Make sure _global-js.liquid is loaded.');
}

const { Core, Events, Utils } = (Global || {});
const { $state } = (Utils || {});
const PREFIX_BUY_WITH = 'buy_with_';

// Only define custom element if Core is available
if (Core) {
  customElements.define('product-form', class extends Core {
    propTypes = {
        'multiple-products': Boolean
    }

    elements = {
        toCartButton: 'product-to-cart',
        form: '[data-type=add-to-cart-form]'
    }

    render() {
        // Get fixed product info from global variable set in <script>
        if (window.wproduct) {
            this.fixedProductId = window.wproduct.variant;
            this.fixedSellingPlanId = window.wproduct.meta?.selling_plan_id || null;
        }

        this.$('form', {
            submit: this._submitHandler.bind(this)
        });
    }

//    async _submitHandler(e) {
//     e.preventDefault();
//     this._validateForm();

//     if (this.prop('multiple-products')) {
//         this.$('toCartButton').addToCart(this.cartItems);
//         return;
//     }

//     try {
//         const cart = await $.getJSON('/cart.js');
//         const items = this.cartItems.slice(); // clone

//         const staticVariantId = window.wproduct?.variant;
//         const sellingPlanId = window.wproduct?.meta?.selling_plan_id;

//         if (staticVariantId) {
//             const alreadyInCart = cart.items.some(item =>
//                 item.variant_id === staticVariantId
//             );

//             if (!alreadyInCart) {
//                 console.log('Adding static product to form submission');
//                 items.push({
//                     id: staticVariantId,
//                     quantity: 1,
//                     ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
//                 });
//             } else {
//                 console.log('Static product already in cart, not adding.');
//             }
//         } else {
//             console.warn('Static product ID missing — check window.wproduct');
//         }

//         console.log('Final items being added to cart:', items);

//         $.ajax({
//             type: 'POST',
//             url: '/cart/add.js',
//             data: JSON.stringify({ items }),
//             contentType: 'application/json',
//             dataType: 'json',
//             success: async (response) => {
//                 console.log('Successfully added to cart:', response);
//                 this.pub(Events.CART_DRAWER_OPEN);
                
//                 // Fetch updated cart JSON
//                 const cart = await fetch('/cart.js').then(r => r.json());
//                 // Dispatch custom event with cart details
//                 document.dispatchEvent(new CustomEvent('cart:items-added', { detail: { cart } }));

//                 document.dispatchEvent(new Event('cart:refresh')); // Existing event for UI update
//             },
//             error: (xhr, status, error) => {
//                 console.error('Failed to add to cart:', error, xhr.responseText);
//             }
//         });

//         this.pub(Events.PRODUCT_FORM_SUBMIT, {
//             formData: this.formData
//         });

//     } catch (error) {
//         console.error('Error during form submit:', error);
//     }
// }
async _submitHandler(e) {
    e.preventDefault();
    this._validateForm();

    const formEl = this.$('form');

    try {
        // --- Step 1: Collect main product data ---
        const formData = new FormData(formEl);
        const mainItemId = parseInt(formData.get('id'));
        const mainQuantity = parseInt(formData.get('quantity')) || 1;

        const itemsToAdd = [{ id: mainItemId, quantity: mainQuantity }];

        // --- Step 2: Check cart for static product and add if missing ---
        // OPTIMIZATION: Fetch cart in parallel with collecting addon data to minimize delay
        // This ensures we only add subscription product if it's not already in cart
        // (Requirements: exactly 1 subscription product, all customers need it)
        const staticVariantId = window.wproduct?.variant;
        const sellingPlanId = window.wproduct?.meta?.selling_plan_id;
        
        // Start cart fetch early (in parallel with addon collection)
        const cartCheckPromise = staticVariantId ? fetch('/cart.js').then(r => r.json()) : Promise.resolve({ items: [] });
        
        // --- Step 3: Add checked addons (while cart check is happening) ---
        const addonCheckboxes = document.querySelectorAll('.addon_checkbox');
        const addons = Array.from(addonCheckboxes)
            .filter(cb => cb.checked)
            .map(cb => ({ id: parseInt(cb.value), quantity: 1 }))
            .filter(Boolean);
        itemsToAdd.push(...addons);

        // Now check if static product is needed (cart check completes here)
        if (staticVariantId) {
            const cart = await cartCheckPromise;
            const hasStaticProduct = cart.items?.some(item => item.variant_id === staticVariantId);
            
            // Only add static product if it's not already in cart
            // This ensures exactly 1 subscription product at all times
            if (!hasStaticProduct) {
                itemsToAdd.push({
                    id: staticVariantId,
                    quantity: 1,
                    ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
                });
            }
        }

        console.log("[ATC] Final items:", itemsToAdd);

        // --- Step 4: Add all items via single AJAX request ---
        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd })
        });
        
        // Check if the request was successful
        if (!addResponse.ok) {
            const errorData = await addResponse.json().catch(() => ({}));
            throw new Error(errorData.description || errorData.message || 'Failed to add item to cart');
        }
        
        const addedItems = await addResponse.json();
        console.log("[ATC] Items added:", addedItems);

        // --- Step 5: Open cart drawer INSTANTLY (optimistic UI) ---
        // OPTIMIZATION: Open drawer immediately after successful add request
        // This makes the UI feel instant - user sees feedback before any other operations
        this.pub(Events.CART_DRAWER_OPEN);
        document.dispatchEvent(new CustomEvent("pub", { detail: { event: "CART_DRAWER_OPEN" } })); 
        const cartTrigger = document.querySelector('.cart__icon_button');
        if (cartTrigger) {
            cartTrigger.click();
            console.log("Cart drawer opened instantly for immediate feedback");
        }

        // --- Step 6: Background operations (run in parallel, don't block UI) ---
        // OPTIMIZATION: These operations happen asynchronously while user sees the cart drawer
        // The drawer is already open, so we're just updating it with accurate data in the background
        // _syncStaticProduct() will ensure exactly 1 subscription product with quantity 1
        this._updateCartInBackground(addedItems);

    } catch (err) {
        console.error("[ATC] Error adding to cart:", err);
        // Clear loading state and notify user of error
        this.pub(Events.CART_ERROR, err);
        
        // Show error notification to user
        if (err.message) {
            this.pub(Events.TOAST_NOTIFICATION, {
                type: 'error',
                msg: err.message || 'Failed to add item to cart. Please try again.',
                title: 'Error'
            });
        }
    }
}

// Helper method to update cart in background without blocking UI
async _updateCartInBackground(addedItems) {
    try {
        // Fetch updated cart (this happens in background while drawer is already open)
        const updatedCart = await fetch('/cart.js').then(r => r.json());
        
        // Trigger events for free gifts and static product sync
        // These will run asynchronously and update the cart drawer when ready
        document.dispatchEvent(new CustomEvent('cart:items-added', { detail: { cart: updatedCart } }));
        document.dispatchEvent(new Event('cart:refresh'));
    } catch (err) {
        console.error("[ATC] Background cart update error:", err);
        // Don't show error to user - cart drawer is already open, just update silently
    }
}

    _validateForm() {
        this.formData = this._getFormData();

        for (const [key, value] of [...this.formData.entries()]) {
            if (value.trim() === "") this.formData.delete(key);
        }
    }

    _isVariantInput([inputName]) {
        return inputName.includes(PREFIX_BUY_WITH) || inputName === 'id';
    }

    _setCartItem([_, value]) {
        return {
            id: value,
            quantity: 1
        };
    }

    _getFormData() {
        return new FormData(this.$('form'));
    }

    get cartItems() {
        return Array.from(this.formData.entries())
            .filter(this._isVariantInput.bind(this))
            .map(this._setCartItem.bind(this));
    }
  });
} else {
  console.error('product-form.js: Core component not available. Cannot define product-form element.');
}
